import {type Socket} from 'node:net';

export function socketKey(socket: Socket): string {
    const remoteIp = socket.remoteAddress;
    if (!remoteIp) {
        throw new Error('Socket has no remote address');
    }
    return `${remoteIp}:${socket.remotePort}`;
}

